var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-back",
      style: {
        background:
          "url(" +
          require("@/assets/images/testlogin_back.gif") +
          ")" +
          "no-repeat"
      }
    },
    [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("@/assets/images/login-logo.png"), alt: "" }
      }),
      _c("div", { staticClass: "login_outer" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("智能化多媒体管理和生产系统")
        ]),
        _c(
          "div",
          { staticClass: "login-container" },
          [
            _c("div", { staticClass: "login-or-register" }, [_vm._v("登录")]),
            _c(
              "el-form",
              {
                ref: "dynamicValidateForm",
                staticClass: "demo-dynamic",
                attrs: { model: _vm.dynamicValidateForm, rules: _vm.rules }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "email",
                      error: _vm.error1,
                      "show-message": ""
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "邮 箱" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitForm("dynamicValidateForm")
                        }
                      },
                      model: {
                        value: _vm.dynamicValidateForm.email,
                        callback: function($$v) {
                          _vm.$set(_vm.dynamicValidateForm, "email", $$v)
                        },
                        expression: "dynamicValidateForm.email"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "password",
                      error: _vm.error2,
                      "show-message": ""
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "password", placeholder: "密 码" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitForm("dynamicValidateForm")
                        }
                      },
                      model: {
                        value: _vm.dynamicValidateForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.dynamicValidateForm, "password", $$v)
                        },
                        expression: "dynamicValidateForm.password"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "test",
                        staticStyle: { width: "20.21vw", height: "4.3vh" },
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitForm("dynamicValidateForm")
                          }
                        }
                      },
                      [_vm._v("登录")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "bottom" }, [
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticStyle: {
                        "text-decoration": "none",
                        cursor: "pointer"
                      },
                      attrs: {
                        tag: "a",
                        target: "_blank",
                        to: { name: "FindPassword" }
                      }
                    },
                    [_vm._v("忘记密码")]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.goRegister }
                },
                [_vm._v(" 没有账号 ?立即注册 ")]
              )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }